export default __webpack_public_path__ + "static/media/transpaleta_naranja_3000kg.d2349242.jpg";